// extracted by mini-css-extract-plugin
module.exports = {"hero":"fundraising-module--hero--2pAPJ","fundraise_content":"fundraising-module--fundraise_content--3e9p9"};